module.exports = __webpack_public_path__ + "media/images/ln/ln_btn_close-fbbba4a4ec780fa0fd2cc49d1d450c18.png";